export default __webpack_public_path__ + "static/media/Anitech_engineers.54315f83.jpg";